// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Selfies-selfies-028f{gap:16px}.Selfies-selfies-028f>*{flex:1 1 0;aspect-ratio:1/1;max-width:calc(50% - 8px)}`, "",{"version":3,"sources":["webpack://./src/page/ProfileScreen/Selfies/Selfies.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA,CAEA,wBACE,UAAA,CACA,gBAAA,CACA,yBAAA","sourcesContent":[".selfies {\n  gap: 16px;\n\n  > * {\n    flex: 1 1 0;\n    aspect-ratio: 1 / 1;\n    max-width: calc(50% - 8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selfies": `Selfies-selfies-028f`
};
module.exports = ___CSS_LOADER_EXPORT___;
